import User from "../../apis/User";
import Drip from "../../apis/Drip";
import router from "../../router";
import schedules from './schedules';

// To Handle State
const state = {
  recurringToStore: [{
    domain_id: null,
    title: "",
    body: "",
    url: "",
    customization: {
      ttl: 7200,
      requireInteraction: false,
      image: null,
      button1: {
        url: "",
      },
      button2: {
        url: "",
      }
    },
    icon: null,
    schedule: null,
    type: "recurring"
  }],
  recurringDrips: [],
  ungroupedRecurringDrips: [],
  recurringDrip: [],
  errorRecurringDrip: "",
};

// To Handle Actions
const actions = {
  resetRecurringToStore({ commit }) {
    commit("RESET_RECURRING_TO_STORE");
  },
  resetRecurringDrips({ commit }) {
    commit("RESET_RECURRING_DRIPS");
  },
  // Create Or Update
  createOrUpdate({ commit }, { json, withReplaceUrlButtons }) {
    return new Promise((resolve, reject) => {
      Drip.createOrUpdate("recurring", json, withReplaceUrlButtons)
        .then((response) => {
          resolve(response);
          commit("CREATE_OR_UPDATE", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        });
    });
  },
  createRecurringGroup({ commit }, payload) {
    return Drip.storeGroup(payload)
      .then((response) => {
        let modifiedResponse = { ...response.data, drips_count: 0 }
        commit("CREATE_OR_UPDATE", modifiedResponse);
      })
      .catch((err) => {
        if (err.response) {
          commit("DETECT_ERROR", err.response);
        }
      });
  },
  // Get
  getRecurringDrips({ commit }, { params, headers = {
    Accept: "application/json",
  } }) {
    return new Promise((resolve, reject) => {
      Drip.get("recurring", params, headers)
        .then((response) => {
          resolve(response);
          commit("GET_RECURRING_DRIPS", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        });
    });
  },
  getUngroupedRecurringDrips({ commit }, { params, headers = {
    Accept: "application/json",
  } }) {
    return new Promise((resolve, reject) => {
      Drip.get("recurring", params, headers)
        .then((response) => {
          resolve(response);
          commit("GET_UNGROUPED_RECURRING_DRIPS", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        });
    });
  },
  getRecurringGroupIds({ commit }, domainId) {
    return Drip.getRecurringGroupIds(domainId)
      .then((response) => {
        commit("CREATE_OR_UPDATE_BY_GROUP_IDS", response.data);
        return response;
      })
      .catch((err) => {
        if (err.response) {
          commit("DETECT_ERROR", err.response);
        }
        return err;
      });
  },
  getRecurringDripsByGroupId({ commit }, { params }) {
    return Drip.getRecurringDripsByGroupId(params)
      .then((response) => {
        console.log("🚀 ~ .then ~ response:", response)
        commit("CREATE_OR_UPDATE_BY_GROUP_IDS", response.data.data.data);
        return response;
      })
      .catch((err) => {
        if (err.response) {
          commit("DETECT_ERROR", err.response);
        }
        return err;
      });
  },
  getClientRecurringDrips({ commit }, { params, headers = {
    Accept: "application/json",
  } }) {
    return new Promise((resolve, reject) => {
      Drip.get("recurring", params, headers)
        .then((response) => {
          resolve(response);
          commit("GET_CLIENT_RECURRING_DRIPS", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        });
    });
  },
  getRecurringDrip({ commit }, params) {
    return new Promise((resolve, reject) => {
      Drip.get("recurring", params)
        .then((response) => {
          resolve(response);

          // console.log(response)

          // if (!response.data.length) {
          //   router.push({ name: "Page Not Found" });

          //   return false;
          // }

          commit("GET_RECURRING_DRIP", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        });
    });
  },
  async updateRecurringGroupSchedules({ commit }, { groupId, params }) {
    console.log("🚀 ~ updateRecurringGroupSchedules ~ groupId, params:", groupId, params)
    try {
      const res = await Drip.updateRecurringGroupSchedules(params)
      commit('UPDATE_RECURRING_GROUP_SCHEDULE', { response: res.data.results[0], groupId })
      return res.data
    } catch (err) {
      commit("DETECT_ERROR", err?.response || err);
      throw err
    }
  },
  async attachRecurringToGroup({ commit }, { groupId, payload, dripsCount }) {
    try {
      const res = await Drip.attachRecurringToGroup(groupId, payload)
      commit('ATTACH_RECURRING_TO_GROUP', { recurring: res.data, groupId, dripsCount })
      return res.data
    } catch (err) {
      commit("DETECT_ERROR", err?.response || err);
      throw err
    }
  },
  async detachRecurringFromGroup({ commit }, { groupId, payload }) {
    try {
      const res = await Drip.detachRecurringFromGroup(groupId, payload)
      commit('DETACH_RECURRING_TO_GROUP', res.data)
      return res.data
    } catch (err) {
      commit("DETECT_ERROR", err?.response || err);
      throw err
    }
  },
  async deleteRecurringGroup({ commit }, groupId) {
    try {
      const res = await Drip.deleteRecurringGroup(groupId)
      commit('DELETE_RECURRING_GROUP', groupId)
      return res.data
    } catch (err) {
      commit("DETECT_ERROR", err?.response || err);
      throw err
    }
  },
  async toggleRecurringGroup({ commit }, { groupId, payload }) {
    try {
      const res = await Drip.toggleRecurringGroup(groupId, payload)
      commit('TOGGLE_RECURRING_STATUS', { groupId, isActive: payload.is_active })
      return res.data
    } catch (err) {
      commit("DETECT_ERROR", err?.response || err);
      throw err
    }
  },
  deleteDrafts({ commit }, drafts) {
    commit("DELETE_DRAFTS", drafts);
  },
  deleteRecurringDrip({ commit }, data) {
    return new Promise((resolve, reject) => {
      Drip.delete("recurring", data[0], data[1])
        .then((response) => {
          resolve(response);
          commit("DELETE_RECURRING_DRIP", data[1]);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        });
    });
  },
  deleteRecurringDripArray({ commit }, { domainId, ids }) {
    let formData = new FormData();

    formData.append("domain_id", domainId);
    formData.append("ids", ids);

    return new Promise((resolve, reject) => {
      Drip.deleteArray(formData)
        .then((response) => {
          resolve(response);
          commit("DELETE_RECURRING_DRIP_ARRAY", ids);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        });
    });
  },
};

// To Handle Getters
const getters = {
  recurringGetters(state) {
    return state.recurringDrips;
  }
};

// To Handle Mutations
const mutations = {
  CREATE_OR_UPDATE(state, recurring) {
    state.recurringDrips.unshift(recurring)
  },
  CREATE_OR_UPDATE_BY_GROUP_IDS(state, recurring) {
    state.recurringDrips = recurring
  },
  DELETE_DRAFTS(state, drafts) {
    if (drafts.length === state.recurringDrips.length) {
      state.recurringDrips = [];

      return false;
    }

    state.recurringDrips.forEach((recurring, i) => {
      if (drafts.some((el) => el.id == recurring.id)) {
        state.recurringDrips.splice(index, 1);
      }
    });
  },
  ATTACH_RECURRING_TO_GROUP(state, { recurring, groupId, dripsCount }) {
    let foundRecurringIndex = state.ungroupedRecurringDrips.findIndex(el => el.id === recurring.id)
    let foundGroupIndex = state.recurringDrips.findIndex(el => el.group_uid === groupId)

    if (foundRecurringIndex !== -1) {
      state.ungroupedRecurringDrips.splice(foundRecurringIndex, 1);
    }

    if (foundGroupIndex !== -1) {
      state.recurringDrips[foundGroupIndex].drips_count += dripsCount
    }
  },
  DETACH_RECURRING_TO_GROUP(state, recurring) {
    console.log("🚀 ~ DETACH_RECURRING_TO_GROUP ~ recurring:", recurring)
    let foundRecurringIndex = state.recurringDrips.findIndex(el => el.id == recurring.detached[0])
    console.log("🚀 ~ DETACH_RECURRING_TO_GROUP ~ foundRecurringIndex:", foundRecurringIndex)

    if (foundRecurringIndex !== -1) {
      state.recurringDrips.splice(foundRecurringIndex, 1);
    }
  },
  DELETE_RECURRING_GROUP(state, groupId) {
    let foundRecurringIndex = state.recurringDrips.findIndex(el => el.group_uid == groupId)
    console.log("🚀 ~ DELETE_RECURRING_GROUP ~ foundRecurringIndex:", foundRecurringIndex, groupId)

    if (foundRecurringIndex !== -1) {
      state.recurringDrips.splice(foundRecurringIndex, 1);
    }
  },
  TOGGLE_RECURRING_STATUS(state, { groupId, isActive }) {
    let foundRecurringIndex = state.recurringDrips.findIndex(el => el.group_uid === groupId)

    if (foundRecurringIndex !== -1) {
      state.recurringDrips[foundRecurringIndex].is_active = isActive;
    }
  },
  RESET_RECURRING_TO_STORE(state) {
    state.recurringToStore = [{
      domain_id: null,
      title: "",
      body: "",
      url: "",
      customization: {
        ttl: 7200,
        requireInteraction: false,
        image: null,
        button1: {
          url: "",
        },
        button2: {
          url: "",
        }
      },
      icon: null,
      schedule: null,
      type: "recurring"
    }];
  },
  RESET_RECURRING_DRIPS(state) {
    state.recurringDrips = [];
  },
  // Get
  GET_RECURRING_DRIPS(state, drips) {
    state.recurringDrips = drips["data"] != undefined ? drips["data"] : drips;
  },
  GET_UNGROUPED_RECURRING_DRIPS(state, drips) {
    state.ungroupedRecurringDrips = drips["data"] != undefined ? drips["data"] : drips;
  },
  GET_CLIENT_RECURRING_DRIPS(state, drips) {
    state.recurringDrips = drips["data"] != undefined ? drips["data"] : drips;
  },
  GET_RECURRING_DRIP(state, drip) {
    state.recurringDrip = drip;
  },
  UPDATE_RECURRING_DRIP_OBJ(state, drip) {
    state.recurringDrips = drip;
  },
  UPDATE_RECURRING_GROUP_SCHEDULE(state, { response, groupId }) {
    let index = state.recurringDrips.findIndex(el => el.group_uid === groupId)
    
    if (index !== -1) {
      state.recurringDrips[index].drips_count = response.drips_count
    }
    
    console.log("🚀 ~ UPDATE_RECURRING_GROUP_SCHEDULE ~ response:", response, index)
  },
  // Delete
  DELETE_RECURRING_DRIP(state, id) {
    let obj = state.recurringDrips.findIndex((el) => el.id === id);
    state.recurringDrips.splice(obj, 1);
  },
  DELETE_RECURRING_DRIP_ARRAY(state, id) {
    let obj;
    id = id.split(',');

    for (let i in id) {
      obj = state.recurringDrips.findIndex((el) => el.id == id[i]);
      state.recurringDrips.splice(obj, 1);
    }
  },
  // Detect Error Mutation
  DETECT_ERROR(state, error) {
    if (error.status == 401 || error.status == 419) {
      User.logout().then(() => {
        localStorage.removeItem("auth");
        router.push({ name: "Login", path: router.currentRoute.path });
      });
    } else if (error.data.message !== undefined) {
      state.errorRecurringDrip = error.data.message;
    }

    setTimeout(() => {
      state.errorRecurringDrip = "";
    }, 1000);
  },
};

// Export
export default {
  state,
  actions,
  getters,
  mutations,
};
